const { $ } = window;

const { Swiper, Navigation, Pagination } = window.swiper;

$(() => {
  const snapSliderElement = document.querySelector(".c-content-snaps__slider");
  if (snapSliderElement) {
    const snapSlider = new Swiper(snapSliderElement, {
      loop: true,
      loopAdditionalSlides: 10,
      loopedSlidesLimit: false,
      centeredSlides: true,
      grabCursor: true,
      slidesPerView: "auto",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  const relatedSliderElementList = document.querySelectorAll(
    ".c-single-snaps__related-slider"
  );
  // eslint-disable-next-line no-restricted-syntax
  for (const relatedSliderElement of relatedSliderElementList) {
    const relatedSlider = new Swiper(relatedSliderElement, {
      loop: true,
      loopAdditionalSlides: 10,
      loopedSlidesLimit: false,
      centeredSlides: true,
      grabCursor: true,
      slidesPerView: "auto",
      effect: "coverflow",
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 500,
        modifier: 1,
        slideShadows: false,
      },
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
});
